<template>
  <div class="subject">
    <router-link
      v-if="status === 'DRAFT' || status === 'DOWNLOADED'"
      :to="`/campaign/${id}`"
      class=""
    >
      {{ subject }}
    </router-link>

    <component
      :is="nonDraftType"
      v-else
      :href="previewUrl"
      target="_blank"
      class="text-support mb-0"
    >
      {{ subject }}
      <p
        v-if="!previewUrl"
        class="no-preview"
      >
        Preview currently unavailable
      </p>
    </component>
  </div>
</template>

<script>
export default {
  name: "CampaignListSubject",
  props: {
    id: {
      type: String,
      required: true
    },
    previewUrl: {
      type: String,
      default: ""
    },
    status: {
      type: String,
      required: true
    },
    subject: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      nonDraftType: this.previewUrl ? "a" : "p"
    };
  }
};
</script>

<style scoped>
.subject {
  @apply pl-0 font-bold font-lato text-support mb-2 text-sm text-center;

  &:hover {
    @apply no-underline;
  }

  @screen md {
    @apply text-base;
  }

  @screen lg {
    @apply text-lg text-left mb-0 mr-6;
  }

  @screen xl {
    @apply text-xl;
  }
}

.no-preview {
  @apply text-xs font-sans font-light text-grey-dark;
  margin-top: -2px;
}
</style>
